export default __webpack_public_path__ + "static/media/sec1.8c64f80c.svg";